

import React, { useState, useEffect, useRef,  } from "react";
import { Link } from "react-router-dom";

const CartPage = () => {
    const [plates, setPlates] = useState(2);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [showPaymentSection, setShowPaymentSection] = useState(false);
     const [isHovered, setIsHovered] = useState(false);
      const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


 
    const [cartItems, setCartItems] = useState([
        { id: 1, category: "Main Course", type: "Veg", name: "Paneer Butter Masala", price: 200 },
        { id: 2, category: "Bread", type: "Veg", name: "Butter Naan", price: 50 },
        { id: 3, category: "Dessert", type: "Veg", name: "Gulab Jamun", price: 80 }
    ]);

    const [vegPlates, setVegPlates] = useState(2);
    const [nonVegPlates, setNonVegPlates] = useState(1);
    const [mixedPlates, setMixedPlates] = useState(1);

 
  const [paymentMode, setPaymentMode] = useState(""); // "partial" | "full"



  const handlePartialPayment = () => {
    setPaymentMode("partial");
    setShowPaymentSection(true);
    setPaymentMethod(""); // reset
  };

  const handleFullPayment = () => {
    setPaymentMode("full");
    setShowPaymentSection(true);
    setPaymentMethod(""); // reset
  };

    const priceVeg = 200;
    const priceNonVeg = 250;
    const priceMixed = 220;

    // ✅ Subtotals
    const totalVeg = vegPlates * priceVeg;
    const totalNonVeg = nonVegPlates * priceNonVeg;
    const totalMixed = mixedPlates * priceMixed;

    // ✅ Total before discount/tax
    const subTotal = totalVeg + totalNonVeg + totalMixed;

    // ✅ Charges
    const discount = subTotal * 0.1; // 10%
    const sgst = subTotal * 0.09;
    const cgst = subTotal * 0.09;
    const deliveryCharge = 50;

    // ✅ Grand Total
    const afterDiscount = subTotal - discount;
    const grandTotal = afterDiscount + sgst + cgst + deliveryCharge;

    const pricePerPlate = 200;

    const discountPercent = 10;
    const sgstPercent = 9;
    const cgstPercent = 9;

    const totalPrice = cartItems.reduce((sum, item) => sum + item.price, 0) * plates;

    const advancePayment = (grandTotal * 40) / 100;





    const platformCharge = 30;


    // Totals
    const vegTotal = vegPlates * priceVeg;
    const nonVegTotal = nonVegPlates * priceNonVeg;
    const mixedTotal = mixedPlates * priceMixed;



    const removeItem = (id) => {
        setCartItems(cartItems.filter(item => item.id !== id));
    };

    const handleBookNow = () => {
        setShowPaymentSection(true);
        // Scroll to payment section
        setTimeout(() => {
            const element = document.getElementById("payment-section");
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }, 100);
    };

    // Reset payment section when cart items change
    useEffect(() => {
        setShowPaymentSection(false);
        setPaymentMethod("");
    }, [cartItems, plates]);



    const scrollContainerRef = useRef(null);
    
      const orderPosts = [
        { dishId: 1, orderType: "Dine-In" },
        { dishId: 2, orderType: "Take Away" },
        { dishId: 3, orderType: "Delivery" },
      ];
    
      // Auto-scroll for right panel
      useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
    
        let interval = setInterval(() => {
          if (!isHovered) {
            scrollContainer.scrollTop += 1;
            if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
              scrollContainer.scrollTop = 0;
            }
          }
        }, 20);
    
        return () => clearInterval(interval);
      }, [isHovered]);
    
      // Mobile resize check
      useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    

    return (
        <div style={styles.container}>
            <p
          className="breadcrumb maamaas-home-bredcumsyy"
          style={{
            position: "fixed",
            top: "63px",
            left: '191px',
            width: "100%",
            backgroundColor: "#fff",
            zIndex: 1000,
            padding: "10px 0",
            fontSize: "18px",
            fontWeight: "bold",
            textAlign: "center",
            margin: 0,
          }}
        >
          <Link
            to="/"
            style={{
              color: "purple",
              fontWeight: "bold",
              textDecoration: "none",
            }}
          >
            Home
          </Link>
          <span className="separator"> &gt; </span>
          <Link
            to="/Categringcart"
            style={{
              color: "purple",
              fontWeight: "bold",
              textDecoration: "none",
            }}
          >
            Catering
          </Link>


        </p>
            {/* Column 2 - Sidebar */}
            <div style={styles.col2}>
                <div style={styles.profileBox}>
                    <img
                        src="https://via.placeholder.com/100"
                        alt="Profile"
                        style={styles.circleImage}
                    />
                    <h3>Welcome User</h3>
                </div>
            </div>

            {/* Column 7 - Cart Details */}
            <div style={styles.col7}>
                <h2 style={styles.heading}>🛒 Your Catering Cart</h2>

                {/* Cart Table */}
                <div style={styles.tableContainer}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th>Sr.No</th>
                                <th>Category</th>
                                <th>Type</th>
                                <th>Item</th>

                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cartItems.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.category}</td>
                                    <td>{item.type}</td>
                                    <td>{item.name}</td>

                                    <td>
                                        <button
                                            style={styles.removeBtn}
                                            onClick={() => removeItem(item.id)}
                                        >
                                             Remove
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Billing Summary */}

                <div style={styles.summaryBox}> <h3> Billing Summary</h3> {/* Top Plates Box */} <div style={styles.platesBox}> <div style={styles.plateRow}> <span>Veg Plates:</span> <input type="number" min="0" value={vegPlates} onChange={(e) => setVegPlates(Number(e.target.value))} style={styles.input} /> <span>× ₹{priceVeg} = ₹{vegTotal}</span> </div> <div style={styles.plateRow}> <span>Non-Veg Plates:</span> <input type="number" min="0" value={nonVegPlates} onChange={(e) => setNonVegPlates(Number(e.target.value))} style={styles.input} /> <span>× ₹{priceNonVeg} = ₹{nonVegTotal}</span> </div> <div style={styles.plateRow}> <span>Mixed Plates:</span> <input type="number" min="0" value={mixedPlates} onChange={(e) => setMixedPlates(Number(e.target.value))} style={styles.input} /> <span>× ₹{priceMixed} = ₹{mixedTotal}</span> </div> </div> {/* Charges Box */} <div style={styles.chargesBox}> <div style={styles.chargeItem}> <span>Delivery Charge:</span> <span>₹{deliveryCharge}</span> </div> <div style={styles.chargeItem}> <span>Platform Charge:</span> <span>₹{platformCharge}</span> </div> <div style={styles.chargeItem}> <span>Discount ({discountPercent}%):</span> <span>-₹{discount.toFixed(2)}</span> </div> <div style={styles.chargeItem}> <span>SGST ({sgstPercent}%):</span> <span>₹{sgst.toFixed(2)}</span> </div> <div style={styles.chargeItem}> <span>CGST ({cgstPercent}%):</span> <span>₹{cgst.toFixed(2)}</span> </div> <div style={{ ...styles.chargeItem, ...styles.grandTotal }}> <span>Grand Total:</span> <span>₹{grandTotal.toFixed(2)}</span> </div> 
                </div>
                </div>
                
                
      {/* Buttons */}
      {!showPaymentSection && (
        <div style={styles.bookNowBtnContainer}>
          <button style={styles.bookNowBtn} onClick={handlePartialPayment}>
            Partial Payment
          </button>
          <button style={styles.fullBtn} onClick={handleFullPayment}>
            Full Payment
          </button>
        </div>
      )}

      {/* Payment Section */}
      {showPaymentSection && (
        <div style={styles.paymentSection}>
          <h3>  ({paymentMode === "partial" ? "Partial" : "Full"})</h3>

          {/* Payment Method Selection */}
          <div style={styles.paymentMethod}>
            <h4> Payment Method:</h4>
            <div style={styles.methodOptions}>
  <button
    style={{
      ...styles.methodBtn,
      backgroundColor: paymentMethod === "online" ? "#21ba45" : "#f0f0f0",
      color: paymentMethod === "online" ? "#fff" : "#333",
    }}
    onClick={() => setPaymentMethod("online")}
  >
    Online Payment
  </button>

  <button
    style={{
      ...styles.methodBtn,
      backgroundColor: paymentMethod === "cash" ? "#21ba45" : "#f0f0f0",
      color: paymentMethod === "cash" ? "#fff" : "#333",
    }}
    onClick={() => setPaymentMethod("cash")}
  >
    Cash on Delivery
  </button>

  <button
    style={{
      ...styles.methodBtn,
      backgroundColor: paymentMethod === "wallet" ? "#21ba45" : "#f0f0f0",
      color: paymentMethod === "wallet" ? "#fff" : "#333",
    }}
    onClick={() => setPaymentMethod("wallet")}
  >
    Wallet
  </button>
</div>

          </div>

          {/* Show Payment Amount Only After Selecting Method */}
          {paymentMethod && (
            <div style={styles.paymentOptions}>
              {paymentMode === "partial" && (
                <div style={styles.paymentItem}>
                  <div>
                    <h4>Advance Payment (40%)</h4>
                    <p>₹{advancePayment.toFixed(2)} (Mandatory)</p>
                  </div>
                  <button style={styles.payBtn}>Pay Now</button>
                </div>
              )}

              {paymentMode === "full" && (
                <div style={styles.paymentItem}>
                  <div>
                    <h4>Full Payment</h4>
                    <p>₹{grandTotal.toFixed(2)}</p>
                  </div>
                  <button style={styles.fullPayBtn}>Pay Now</button>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  


            {/* Column 3 - Advertisement */}
             <div style={styles.col3}>
          <div
  className="card"
  style={{
    height: "650px",   // ✅ fix height
    width: "342px",
    marginTop:"-23px",
    border: "none",
    borderRadius: "8px",
    padding: "10px",
    overflow: "hidden", // ✅ outer div scroll na kare
  }}
>
            <div
              ref={scrollContainerRef}
              style={{
                maxHeight: "650px",
                overflowY: "auto",
                paddingRight: "5px",
                scrollbarWidth: "none",
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {orderPosts.concat(orderPosts).map((post, index) => (
                <div
                  key={`${post.dishId}-${index}`}
                  className="card mb-3 text-center text-white"
                  style={{
                    background: "#9937caff",
                    borderRadius: "8px",
                    height: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h6>{post.orderType}</h6>
                  <button className="btn btn-sm btn-light fw-bold mt-2">
                    Add to cart
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
        </div>
    );
};

// Styles
const styles = {
    container: {
        display: "grid",
        gridTemplateColumns: "2fr 7fr 3fr",
        gap: "20px",
        marginTop: "116px",
        padding: "20px",
        // backgroundColor: "#f5f5f5",
        minHeight: "calc(100vh - 116px)",
        boxSizing: "border-box",
    },
    col2: {
        background: "#f1f1f1",
        padding: "15px",
        borderRadius: "10px",
        textAlign: "center",
        position: "sticky",
        top: "136px",
        height: "fit-content",
        alignSelf: "start",
    },
    profileBox: {
        background: "#fff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        marginBottom: "15px",
    },
    circleImage: {
        width: "100px",
        height: "100px",
        borderRadius: "50%",
        marginBottom: "10px",
    },
    col7: {
        background: "#fff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    heading: {
        marginBottom: "15px",
        textAlign: "center",
        color: "#333",
    },
    tableContainer: {
        overflowX: "auto",
        scrollbarWidth:'none',
        marginBottom: "20px",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        borderBottom: "1px solid #eee",
    },
    tableHead: {
        background: "#f5f5f5",
    },
    removeBtn: {
        padding: "6px 10px",
        background: "#ff4757",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "12px",
    },
    summaryBox: {
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        marginTop: "20px",
    },

    platesBox: {
        background: "#f9f9f9",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "15px",
        marginBottom: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },

    plateRow: {
        display: "grid",
        gridTemplateColumns: "1fr auto auto",
        alignItems: "center",
        gap: "10px",
        paddingBottom: "8px",
        borderBottom: "1px solid #eee",
    },

    input: {
        width: "80px",
        padding: "6px",
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: "6px",
    },

    chargesBox: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },

    chargeItem: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #eee",
        paddingBottom: "6px",
    },

    grandTotal: {
        fontWeight: "bold",
        fontSize: "18px",
        borderTop: "2px solid #000",
        paddingTop: "10px",
        marginTop: "10px",
    },

    rightBox: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },
    chargeItem: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #eee",
        paddingBottom: "6px",
    },
    grandTotal: {
        fontWeight: "bold",
        fontSize: "18px",
        borderTop: "2px solid #000",
        paddingTop: "8px",
    },
    input: {
        width: "60px",
        padding: "5px",
        textAlign: "center",
        border: "1px solid #ddd",
        borderRadius: "4px",
    },
    bookNowBtnContainer: {
        textAlign: "center",
        marginTop: "20px",
    },
    bookNowBtn: {
  padding: "12px 30px",
  background: "#ee6521",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "bold",
  marginRight: "15px",  // ✅ next button ke bich space
},

fullBtn: {
  padding: "12px 30px",
  background: "#ee6521",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "bold",
},

    paymentSection: {
        padding: "20px",
         background: "#ee6521",
        borderRadius: "10px",
        marginTop: "20px",
    },
   methodOptions: {
  display: "flex",
  gap: "10px",
  marginTop: "10px",
},

methodBtn: {
  padding: "8px 18px",
  border: "1px solid #ccc",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: "500",
  backgroundColor: "#f0f0f0",
  transition: "all 0.3s ease",
},

    methodLabel: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        cursor: "pointer",
    },
    paymentOptions: {
        display: "flex",
        flexDirection: "column",
        gap: "15px",
    },
    paymentItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "15px",
        background: "#fff",
        marginTop:'20px',
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    payBtn: {
        padding: "8px 16px",
        background: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        minWidth: "100px",
    },
    fullPayBtn: {
        padding: "8px 16px",
        background: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        minWidth: "100px",
    },
    col3: {
        
        padding: "15px",
        borderRadius: "10px",
        textAlign: "center",
        position: "sticky",
        top: "136px",
        height: "fit-content",
        alignSelf: "start",
    },
    adBox: {
        height: "300px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
    },
    // Media queries for responsiveness
    "@media (max-width: 1200px)": {
        container: {
            gridTemplateColumns: "1fr 2fr",
        },
        col3: {
            display: "none",
        },
    },
    "@media (max-width: 768px)": {
        container: {
            gridTemplateColumns: "1fr",
            marginTop: "90px",
            padding: "10px",
        },
        col2: {
            position: "relative",
            top: "0",
        },
        col7: {
            padding: "15px",
        },
        summaryGrid: {
            gridTemplateColumns: "1fr",
        },
        grandTotal: {
            gridColumn: "1",
        },
        paymentItem: {
            flexDirection: "column",
            gap: "10px",
            textAlign: "center",
        },
        methodOptions: {
            flexDirection: "column",
            alignItems: "flex-start",
        },

        
    },
};

// Add responsive styles
const responsiveStyles = {
    ...styles,
    container: {
        ...styles.container,
        [`@media (max-width: ${1200}px)`]: {
            gridTemplateColumns: "1fr 2fr",
        },
        [`@media (max-width: ${768}px)`]: {
            gridTemplateColumns: "1fr",
            marginTop: "90px",
            padding: "10px",
        },
    },
    col2: {
        ...styles.col2,
        [`@media (max-width: ${768}px)`]: {
            position: "relative",
            top: "0",
        },
    },
    col3: {
        ...styles.col3,
        [`@media (max-width: ${1200}px)`]: {
            display: "none",
        },
    },
    summaryGrid: {
        ...styles.summaryGrid,
        [`@media (max-width: ${768}px)`]: {
            gridTemplateColumns: "1fr",
        },
    },
    grandTotal: {
        ...styles.grandTotal,
        [`@media (max-width: ${768}px)`]: {
            gridColumn: "1",
        },
    },
    paymentItem: {
        ...styles.paymentItem,
        [`@media (max-width: ${768}px)`]: {
            flexDirection: "column",
            gap: "10px",
            textAlign: "center",
        },
    },
    methodOptions: {
        ...styles.methodOptions,
        [`@media (max-width: ${768}px)`]: {
            flexDirection: "column",
            alignItems: "flex-start",
        },
    },
};

// Apply responsive styles
Object.assign(styles, responsiveStyles);

export default CartPage;


